import { ECampaignAgentAccessScope } from '~/features/campaigns/models'

export type TCloneScopeMode = 'current' | 'allLocations' | 'selectLocations'

export enum ENonSharedCloneTargetMode {
  originalAssistant = 'originalAssistant',
  currentAssistant = 'currentAssistant',
  selectAssistants = 'selectAssistants',
}

export type TCloneDialogOptions = {
  agentIds: string[]
  agentAccessScope?: ECampaignAgentAccessScope
  cloneJunctionContent: boolean
}
